<template>
  <footer class="border-t py-12" :class="isDark ? 'bg-gray-900 border-gray-800' : 'bg-white border-gray-200'">
    <div class="max-w-6xl mx-auto px-6">
      <div class="grid md:grid-cols-4 gap-8 mb-8">
        <div>
          <div class="flex items-center space-x-2 mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
            </svg>
            <span class="text-xl font-bold text-green-400">panzhijie.cn</span>
          </div>
          <p class="text-sm leading-relaxed" :class="isDark ? 'text-gray-400' : 'text-gray-600'">
            热爱编程，分享技术。专注于 Web 开发和技术笔记。
          </p>
        </div>
        <div>
          <h4 class="font-medium mb-4" :class="isDark ? 'text-white' : 'text-gray-800'">快速链接</h4>
          <ul class="space-y-2">
            <li><router-link to="/" class="text-sm transition-colors" :class="isDark ? 'text-gray-400 hover:text-green-400' : 'text-gray-600 hover:text-green-600'">首页</router-link></li>
            <li><router-link to="/blog" class="text-sm transition-colors" :class="isDark ? 'text-gray-400 hover:text-green-400' : 'text-gray-600 hover:text-green-600'">博客</router-link></li>
            <li><router-link to="/tools" class="text-sm transition-colors" :class="isDark ? 'text-gray-400 hover:text-green-400' : 'text-gray-600 hover:text-green-600'">工具</router-link></li>
            <li><router-link to="/about" class="text-sm transition-colors" :class="isDark ? 'text-gray-400 hover:text-green-400' : 'text-gray-600 hover:text-green-600'">关于</router-link></li>
          </ul>
        </div>
        <div>
          <h4 class="font-medium mb-4" :class="isDark ? 'text-white' : 'text-gray-800'">联系信息</h4>
          <ul class="space-y-2">
            <li class="text-sm flex items-center" :class="isDark ? 'text-gray-400' : 'text-gray-600'">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 mr-2 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
              684329
            </li>
            <li class="text-sm flex items-center" :class="isDark ? 'text-gray-400' : 'text-gray-600'">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 mr-2 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              panzhijie@qq.com
            </li>
            <li class="text-sm flex items-center" :class="isDark ? 'text-gray-400' : 'text-gray-600'">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 mr-2 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              温州市鹿城区
            </li>
          </ul>
        </div>
        <div>
          <h4 class="font-medium mb-4" :class="isDark ? 'text-white' : 'text-gray-800'">法律信息</h4>
          <ul class="space-y-2">
            <li><router-link to="/about" class="text-sm transition-colors" :class="isDark ? 'text-gray-400 hover:text-green-400' : 'text-gray-600 hover:text-green-600'">隐私政策</router-link></li>
            <li><router-link to="/about" class="text-sm transition-colors" :class="isDark ? 'text-gray-400 hover:text-green-400' : 'text-gray-600 hover:text-green-600'">使用条款</router-link></li>
            <li><router-link to="/about" class="text-sm transition-colors" :class="isDark ? 'text-gray-400 hover:text-green-400' : 'text-gray-600 hover:text-green-600'">关于我们</router-link></li>
          </ul>
          <div class="flex space-x-3 mt-4">
            <a href="#" class="w-8 h-8 rounded-lg flex items-center justify-center transition-colors group"
               :class="isDark ? 'bg-gray-800 hover:bg-green-600' : 'bg-gray-100 hover:bg-green-500'">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 transition-colors" :class="isDark ? 'text-gray-400 group-hover:text-white' : 'text-gray-600 group-hover:text-white'" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.7-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.831.092-.646.35-1.086.636-1.336-2.22-.253-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.268 2.75 1.026A9.578 9.578 0 0110 4.844c.85.004 1.705.114 2.504.336 1.909-1.294 2.747-1.026 2.747-1.026.546 1.377.203 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.687-4.566 4.935.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.579.688.482C17.138 18.199 20 14.426 20 10.017 20 4.484 15.522 0 10 0z" clip-rule="evenodd" />
              </svg>
            </a>
            <a href="#" class="w-8 h-8 rounded-lg flex items-center justify-center transition-colors group"
               :class="isDark ? 'bg-gray-800 hover:bg-green-600' : 'bg-gray-100 hover:bg-green-500'">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 transition-colors" :class="isDark ? 'text-gray-400 group-hover:text-white' : 'text-gray-600 group-hover:text-white'" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clip-rule="evenodd" />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div class="border-t pt-8 text-center" :class="isDark ? 'border-gray-800' : 'border-gray-200'">
        <p class="text-sm" :class="isDark ? 'text-gray-400' : 'text-gray-500'">
          <span :class="isDark ? 'text-gray-600' : 'text-gray-400'">&lt; </span>
          © 2026 panzhijie.cn. All rights reserved.
          <span :class="isDark ? 'text-gray-600' : 'text-gray-400'"> /&gt;</span>
        </p>
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer"
           class="inline-flex items-center gap-1.5 mt-3 text-xs transition-colors"
           :class="isDark ? 'text-gray-500 hover:text-green-400' : 'text-gray-400 hover:text-green-600'">
          <img :src="`${publicPath}icp_logo_20x20.png`" alt="ICP" class="w-5 h-5" />
          浙ICP备2025173238号-1
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import { useTheme } from '../composables/useTheme'

export default {
  name: 'Footer',
  setup() {
    const { isDark } = useTheme()
    const publicPath = process.env.BASE_URL
    return { isDark, publicPath }
  }
}
</script>
